import React from 'react';
import { withTranslation } from 'react-i18next';
import { t as translate } from 'i18n';
import { Alert } from '@mui/material';

// keeps a render error inside one widget instead of blanking the console
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error) {
    // eslint-disable-next-line no-console
    console.error(`${this.props.name || 'widget'} failed to render`, error);
  }

  render() {
    const { error } = this.state;
    if (error) {
      return (
        <Alert severity="error" sx={{ mb: 2 }}>
          {translate('shell.sectionRenderFailed', { name: this.props.name || translate('shell.thisSection'), error: error.message || String(error) })}
        </Alert>
      );
    }
    return this.props.children;
  }
}

export default withTranslation()(ErrorBoundary);
